module.exports = __webpack_public_path__ + "img/arrow-right.fda1f78c.svg";